import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";

function initSwiper() {
  const swiper = new Swiper(".swiper", {
    modules: [Navigation, Pagination, Autoplay],
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    loop: true,
    navigation: {
      nextEl: ".services__button-next",
      prevEl: ".services__button-prev",
    },
    pagination: {
      el: ".services__pagination",
      clickable: true,
    },

    breakpoints: {
      1240: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
      },
    },
  });
}

export default initSwiper;
